import React from 'react';
import DataGridToolbar from 'components/datagrid/DataGridToolbar';

const MarketingListToolbar = () => {
	return (
		<DataGridToolbar
			persistKey="MarketingList"
			exportFileName="rentle-marketing-list"
			selectedRowsActions={{
				exportAction: {
					enabled: true,
				},
			}}
		/>
	);
};

export default MarketingListToolbar;
